// UC CDR → Analytics: the day-by-day shape of the window, off the same rollups
// as the league table underneath it. Hover a day to read it out.
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { money } from "./ui";

const day = (value) => (value || "").slice(5).replace("-", "/");

export function TrendStrip({ dim, params, currency }) {
  const [days, setDays] = useState([]);
  const [hover, setHover] = useState(null);

  useEffect(() => {
    let live = true;
    api.get("/uc-cdr/analytics/trend", { params: { ...params, dim } })
      .then(({ data }) => { if (live) setDays(data?.days || []); })
      .catch(() => { if (live) setDays([]); });
    return () => { live = false; };
  }, [dim, params]);

  if (days.length < 2) return null;
  const peak = Math.max(...days.map((d) => d.minutes), 1);
  const shown = hover != null ? days[hover] : null;
  const total = days.reduce((a, d) => a + d.minutes, 0);
  const spend = days.reduce((a, d) => a + d.amount, 0);

  return (
    <Card className="px-4 py-3" data-testid="uc-cdr-analytics-trend">
      <div className="flex flex-wrap items-baseline gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">
          Day by day
        </span>
        <span className="text-[12px] text-slate-500" data-testid="uc-cdr-analytics-trend-readout">
          {shown
            ? `${shown.day} · ${Math.round(shown.minutes).toLocaleString()} min · ${(shown.legs || 0).toLocaleString()} legs · ${money(shown.amount, currency)}`
            : `${days.length} days · ${Math.round(total).toLocaleString()} min · ${money(spend, currency)}`}
        </span>
      </div>
      <div className="mt-2 flex h-20 items-end gap-[3px]">
        {days.map((d, i) => (
          <button key={d.day} type="button" title={`${d.day} · ${Math.round(d.minutes).toLocaleString()} min`}
                  className="group flex h-full flex-1 items-end"
                  onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(null)}
                  data-testid={`uc-cdr-analytics-trend-${d.day}`}>
            <span className={`w-full rounded-t transition-colors ${hover === i ? "bg-sky-600" : "bg-sky-300 group-hover:bg-sky-500"}`}
                  style={{ height: `${Math.max(2, (d.minutes / peak) * 100)}%` }} />
          </button>
        ))}
      </div>
      <div className="mt-1 flex justify-between text-[10px] text-slate-400">
        <span>{day(days[0]?.day)}</span>
        <span>{day(days[days.length - 1]?.day)}</span>
      </div>
    </Card>
  );
}
